var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7493 6.37361L11.4823 6.6938L11.7493 7.01399L12.2484 7.61261L10.717 6.6938L12.2484 5.77499L11.7493 6.37361ZM6.73509 7.01399L7.00204 6.6938L6.73509 6.37361L6.23599 5.77499L7.76734 6.6938L6.23599 7.61261L6.73509 7.01399ZM9.24219 0.992188C4.8229 0.992188 1.24219 4.5729 1.24219 8.99219C1.24219 13.4115 4.8229 16.9922 9.24219 16.9922C13.6615 16.9922 17.2422 13.4115 17.2422 8.99219C17.2422 4.5729 13.6615 0.992188 9.24219 0.992188ZM9.00025 13.8148C7.0422 13.8148 5.42319 12.3518 5.17707 10.4599H13.3073C13.0612 12.3518 11.4422 13.8148 9.48412 13.8148H9.00025Z",
    stroke: "#646464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnyUser);
export default __webpack_public_path__ + "static/media/Funny_user.47ee1e4738d2caa1be463a2027f4ce8f.svg";
export { ForwardRef as ReactComponent };